// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1RMqo","addWidgetButton":"Header_addWidgetButton__39DS1","dashboardTabs":"Header_dashboardTabs__2CxvL","active":"Header_active__3RgxY"};